import React, { useState, useEffect } from 'react';
import MensajeAdvertencia from './MensajeAdvertencia';
import LoaderScreen from '../layout/LoaderScreen';
import { useTranslation } from 'react-i18next';
import toast from 'react-hot-toast';
import { useMotivos } from './useMotivos';

const Paso3 = (props) => {
  const { t } = useTranslation();
  
  const poseeBoletos = window.localStorage.getItem("PoseeBoleto");
  const { motivos, loading: loadingMotivos, error: errorMotivos } = useMotivos(poseeBoletos);

  const [caracteresRestantes, setcaracteresRestantes] = useState(300);
  const [Motivo, setMotivo] = useState("");
  const [Observaciones, setObservaciones] = useState("");
  const [ErrorMotivoMsg, setErrorMotivoMsg] = useState("");

  useEffect(() => {
    window.localStorage.setItem("Paso3", btoa(false));
  }, []);

  useEffect(() => {
    if (errorMotivos) {
      toast.error(t('paso3.errorCargaMotivos', errorMotivos));
    }
  }, [errorMotivos, t]);

  function RestarCaracteres(texto) {
    const max = 300;
    setcaracteresRestantes(max - texto.length);
  }

  function asignarMotivo(valor) {
    if (valor !== "") {
      window.localStorage.setItem("Motivo", valor);
      setErrorMotivoMsg("");
      setMotivo(valor);
      window.localStorage.setItem("Paso3", btoa(true));
    } else {
      setErrorMotivoMsg(t('validaciones.campoObligatorio', 'Campo es obligatorio'));
      window.localStorage.removeItem("Motivo");
      setMotivo("");
      window.localStorage.setItem("Paso3", btoa(false));
    }
  }

  function asignarObservacion(valor) {
    if (valor !== "") {
      window.localStorage.setItem("Observaciones", valor);
    } else {
      window.localStorage.removeItem("Observaciones");
    }
    setObservaciones(valor);
  }

  return (
    <>
      <LoaderScreen props={loadingMotivos} mensaje={t('paso3.cargandoMotivos', 'Obteniendo motivos...')} />
      <div className="_pt-30 container-fluid px-0">
        <div className="theme-page-section-header _ta-l">
          <h5 className="theme-page-section-title">{t('paso3.titulo', 'Motivo del reembolso')}</h5>
          <h5 className="feature-subtitle _op-06">
            {t('paso3.subtitulo', 'Todos los campos habilitados y marcados con asteriscos (*) son obligatorios.')}
          </h5>
          <hr className="style-3" />
        </div>
        
        <div className="row mt-4">
          <div className="col-12 col-md-6 mb-3">
            <h5 className="_c-dark">
              <span className="_c-p">*</span> {t('paso3.labelMotivo', 'Motivo')} <span className="_c-p">{ErrorMotivoMsg}</span>
            </h5>
            <div className="theme-payment-page-form-item form-group">
              <i className="fa fa-angle-down"></i>
              <select 
                className="form-control seleccionable w-100"
                onChange={(ev) => asignarMotivo(ev.target.value)}
                value={Motivo}
                disabled={loadingMotivos}
              >
                <option value="">{t('comunes.seleccione', 'Seleccione')}</option>
                {motivos && Object.values(motivos).map((objeto, index) => (
                  <option key={index} value={objeto.ID}>
                    {t(`backend.motivos.${objeto.Description}`, objeto.Description)}
                  </option>
                ))}
              </select>
            </div>
          </div>
          
          <div className="col-12 col-md-6 mb-3">
            <h5 className="_c-dark">{t('paso3.labelObservaciones', 'Observaciones o comentarios')}</h5>
            <div className="theme-payment-page-form-item form-group">
              <textarea
                value={Observaciones}
                className="form-control w-100"
                style={{ resize: 'vertical', minHeight: '100px' }}
                maxLength="300"
                onChange={(ev) => {
                  asignarObservacion(ev.target.value);
                  RestarCaracteres(ev.target.value);
                }}
              />
              <span className="_c-dark d-block mt-2" style={{ fontSize: '0.85rem' }}>
                {t('paso3.maxCaracteres', 'Máximo 300 caracteres')} - (<b>{caracteresRestantes}</b> {t('paso3.caracteresRestantes', 'caracteres restantes')})
              </span>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-12">
            <MensajeAdvertencia />
          </div>
        </div>
      </div>
    </>
  );
}

export default Paso3;